import Utils from '../common/Utils';
import Template from './Template';
/**
 * forum의 시작점
 * @category forum
 * @memberof module:forum
 * @param  {Object} _config={} 설정 옵션
 */
class App {
  constructor(_config = {}) {
    this.config = Object.assign({}, _config);
    this.categoryId = this.config.categoryId;
    this.categoryName = '';
    this.bannerList = {};
    this.el = document.querySelector('.forum-top');
  }

  init() {
    if(!this.categoryId){
      for(let key in this.config.categoryList){
        if(this.config.categoryList[key].board.metaTags[0] != 'writeOff'){
          window.location.href = '/board/forum/list?categoryId='+this.config.categoryList[key].board.id
          return;
        }
      }
      window.location.href = '/board/forum/list?categoryId='+this.config.categoryList[this.config.categoryList.length-1].board.id
      return;
    }
    axios.get(this.config.apiDomain+`/conti/getContentJsonDataMap?service=bns&alias=forum-list&lang=ko-KR`, {
      withCredentials: true
    })
      .then( (response) => {
        for(let key in this.config.categoryList){
          if(this.categoryId[0] == this.config.categoryList[key].board.id){
            this.categoryName = this.config.categoryList[key].board.boardAlias;
          }
        }


        response.data.list.filter((list)=>{
          if(list.categoryName == this.categoryName){
            this.bannerList = list;
            return;
          }
        });

        this.el.appendChild(Template.banner(this.bannerList, this.config.device));

      })
      .catch( (error) => {
        console.log(error);
      });
  }
}
Utils.namespace('nc.bns.forum');

nc.bns.forum = App;
class List {
  constructor(_config = {}) {
    this.config = Object.assign({}, _config);
    this.categoryId = this.config.categoryId;
    this.el = document.querySelector('.forum-lists');
    this.selectEl = document.querySelector('.forum-select');
    this.year = 'all';
    this.page = {currentPage:1, totalPage:1}
    this.lists = [];
    this.filterLists = [];
    this.moreBtn=null;
  }

  init() {
    axios.get(this.config.apiDomain+`/conti/getContentJsonDataMap?service=bns&alias=forum-list&lang=ko-KR`, {
      withCredentials: true
    })
      .then( (response) => {
        let years = [{year:'all', txt:'연도전체'}], checkYears=[];
        response.data.list.filter((data, index) => {

          if(checkYears.indexOf(data.year)  > -1)
          {
            return false;
          }else{
            years.push({year:data.year, txt:data.year});
            checkYears.push(data.year)
            return true;
          }
        });
        this.lists = response.data.list;

        this.selectEl.appendChild(Template.select(years));
        let selectors = document.querySelector('.forum_select');
        selectors.addEventListener('change', (event) => {
          this.year = event.target.value;
          this.reset()
          this.listFilter()
          this.getTemp()
         });
        this.el.after(Template.moreBtn())

        this.moreBtn = document.querySelector('.nc-comment-more');
        this.moreBtn.addEventListener('click', (event) => {
          this.page.currentPage++;
          this.el.appendChild(Template.list( this.listPage(), this.config.categoryList));
        })

        this.listFilter()
        this.getTemp()


       })

      .catch( (error) => {
        console.log(error);
      });
  }
  getTemp(){

    this.el.appendChild(Template.list( this.listPage(), this.config.categoryList));
  }
  listFilter(){
    for (let key in this.lists) {
      let data = this.lists[key];
      if(this.year == data.year || this.year === 'all'){
        this.filterLists.push(data)
      }
    }
    this.page.totalPage = Math.floor((this.filterLists.length-1) / 10) +1
  }
  listPage(){
    if(this.page.currentPage >= this.page.totalPage){
      this.moreBtn.style.display='none';
    }else{
      this.moreBtn.style.display='block';

    }
    return  this.filterLists.slice((this.page.currentPage -1) * 10, this.page.currentPage * 10);
  }
  reset(){
    this.page.totalPage = 1;
    this.page.currentPage = 1;
    while (this.el.firstChild) this.el.removeChild(this.el.firstChild);
    while (this.filterLists.length) this.filterLists.shift();
  }
}
Utils.namespace('nc.bns.forumList');

nc.bns.forumList = List;
